import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PropertiesService} from '../../../admin-services/properties.service';
import {finalize, first, map} from 'rxjs/operators';
import {GlobalConstantsComponent} from '../../../../shared/global-constants/global-constants.component';
import {NgbModal, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {modalAnimation} from '../../../../animation';
import {UserService} from '../../../../services/user-services/user.service';
import {AlertService} from '../../../../services/alert.service';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {CalendarComponent} from '../../../../shared/components/ux/calendar/calendar.component';
import {AdminUserService} from '../../../admin-services/admin-user.service';
import {AdminProcessService} from '../../../admin-services/admin-process.service';
import {forkJoin, from, Observable} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AdminDocumentsService} from '../../../admin-services/admin-documents.service';
import {BirthdateDividedComponent} from 'src/app/shared/components/ux/birthdate-divided/birthdate-divided.component';
import {CareService} from 'src/app/admin/admin-services/care.service';
import {PropertyFilterPipe} from '../../../../pipes/PropertyFilter.pipe';
import {DocManagementComponent} from '../../../components/doc-management/doc-management.component';
import {CityInputComponent} from '../../../../shared/components/ux/inputs/city-input/city-input.component';
import {AddressInputComponent} from '../../../../shared/components/ux/inputs/address-input/address-input.component';
import {CheckImageUrlDirective} from '../../../../directives/check-image-url.directive';
import {
  BirthdateDividedComponent as BirthdateDividedComponent_1
} from '../../../../shared/components/ux/birthdate-divided/birthdate-divided.component';
import {PreviewBookingComponent} from './preview-booking/preview-booking.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {IconComponent} from '../../../../shared/components/icons-svgs/icons-svgs.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {Select2Module} from 'ng-select2-component';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DatePipe, DecimalPipe, JsonPipe, NgClass, NgFor, NgIf, NgOptimizedImage} from '@angular/common';
import {UploadFileComponent} from '../../../../shared/components/upload-file/upload-file.component';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MatTooltip} from '@angular/material/tooltip';
import {HelperService} from "../../../../services/helper.service";
import {PlatformService} from "../../../../services/platform-service.service";
import { LocalSettingsService } from 'src/app/services/local-settings.service';
import {environment} from '../../../../../environments/environment'
import { ExportCsvService } from 'src/app/services/export-csv.service';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
  animations: modalAnimation,
  standalone: true,
  imports: [NgIf, MatFormFieldModule, MatIconModule, MatInputModule, FormsModule, NgxIntlTelInputModule, MatSelectModule, MatOptionModule, NgClass, ReactiveFormsModule, Select2Module, NgFor, NgbPopoverModule, ClipboardModule, IconComponent, MatPaginatorModule, PreviewBookingComponent, BirthdateDividedComponent_1, CalendarComponent, CheckImageUrlDirective, AddressInputComponent, CityInputComponent, DocManagementComponent, TranslateModule, DecimalPipe, DatePipe, PropertyFilterPipe, UploadFileComponent, MatRadioButton, MatRadioGroup, NgOptimizedImage, MatTooltip, JsonPipe]
})
export class BookingsComponent implements OnInit, AfterViewInit, OnDestroy {

  public bookings: any[] = [];
  allBookings: { property_id: number[], user_id: number[], house_id: any[] };
  public filterType: string = null;
  public filterDirection = 'asc';
  public isLoading = false;
  public hasChangedFilter = false;
  public hasMoreToLoad = true;
  public isButtonDisabled: string;
  public statutFC: FormControl = new FormControl<string | null>('A traiter/En attente');
  public annulationFC: FormControl = new FormControl<string | null>(null);
  public contactFC: FormControl = new FormControl<string | null>(null);
  public metropoleFC: FormControl = new FormControl<string | null>(null);
  public partnerFC: FormControl = new FormControl<string | null>(null);
  public sortFC: FormControl = new FormControl<string | null>(null);
  public dateFC: FormControl = new FormControl<string | null>(null);
  public dateEnd: FormControl = new FormControl<string | null>(null);
  public dateExact: FormControl = new FormControl<string | null>(null);
  public createdAtStart: FormControl = new FormControl<string | null>(null);
  public createdAtEnd: FormControl = new FormControl<string | null>(null);
  public createdAtExact: FormControl = new FormControl<string | null>(null);
  public validatedAtFC: FormControl = new FormControl(null);
  public minDurationFilter: FormControl = new FormControl<string | null>(null);
  public cautionType: FormControl = new FormControl<string | null>(null);
  public isStudentResidence: FormControl = new FormControl<string | null>(null);
  public isInNationalityList: FormControl = new FormControl<string | null>(null);
  public validatedAtValues = {
    choice: 'at',
    min: null,
    max: null,
  };
  public agentList: any[] = [];
  public metropoleList: any[] = [];
  public partnerList: any[] = [];
  public currentSearch = '';
  public additionalAddressFormControl: UntypedFormControl;
  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL;
  public currentBooking = null;
  public loadingPayment = false;
  public canSend = false;
  public selectedReason: string;
  public endPage;
  public isModif = false;
  public oldFilter;
  public isRapidFilter = 'None';


  @ViewChild('CalendarComponent') private CalendarComponent: CalendarComponent;
  @ViewChild('birthdateDividedComponent') private birthdateComponent: BirthdateDividedComponent;

  public isModalOpen: boolean;
  public booking: any;
  public userCountry: any;
  public idPhoto: any;
  public lettreAdmisssion: any;
  public searchText: any;
  public selectedRooms: any[];
  public isOptionOpened = false;
  public form: UntypedFormGroup;
  public selectedBookingId: number | null = null;
  public editingItem: string = null;
  public contacts: any;
  public displayedAddress: string;
  public birthCountry: any;
  public userFormattedAddress: { route: any; postal_code: any; city_id: any; country: any; };
  public isBirthdayCorrect = true;
  public isFormSubmitted = false;
  public perPage = 100;
  public emailError;
  public isFetchingDatas = false;
  public isSending: boolean;
  public formNote: UntypedFormGroup;
  public isUpdatingBooking = false;
  public dateType: string;
  public refusalArray: string[] = ['Séjour trop court', 'Grand nombre de demande sur le logement', 'Demande à risque (cautionnement)', 'Trop tôt', 'Indisponible', 'Déja loué', 'Autre'];
  public statutArray: { text: string, value: string }[] = [
    {text: 'Tous', value: 'null'},
    {text: 'En attente', value: 'A traiter/En attente'},
    {text: 'En cours', value: 'Validé'},
    {text: 'Refusé', value: 'Refusé'},
    {text: 'Annulé', value: 'Annulé'},
    {text: 'Terminé', value: 'Terminé'},
  ];
  public sortArray: { text: string, value: string }[] = [
    {text: 'Nom de l\'utilisateur', value: 'username'},
    {text: 'Email de l\'utilisateur', value: 'email'},
    {text: 'Date et heure de réservation', value: 'date'},
    {text: 'Nom de la chambre', value: 'room'},
    {text: 'Nom du partenaire', value: 'partner'},
    {text: 'Propriétaire de contact', value: 'contact'},
    {text: 'Durée de séjour', value: 'duration'}
  ];
  public pendingArray = [
    {name: 'Tous', value: null},
    {name: 'Nouveau', value: 'new'},
    {name: 'En attente client', value: 'Client'},
    {name: 'En attente bailleur', value: 'Bailleur'},
  ];
  public pendingFC = new FormControl;
  public LFFees = 0;
  public pdfItem: any;
  public attestationLogement: any;
  public caution: any;
  public booking_invoice;
  public today = new Date();
  public pageIndex = 0;
  public displayedBookings = [];
  public page = 0;
  public totalBookings = 0;
  public queryParams = [];
  public nationalityList: string[] = ['DZ', 'EG', 'LY', 'MA', 'SD', 'TN', 'EH', 'BJ', 'BF',
    'CV', 'CI', 'GM', 'GH', 'GN', 'GW', 'LR', 'ML', 'MR', 'NE', 'NG', 'SN', 'SL', 'TG', 'AO',
    'CM', 'CF', 'TD', 'CG', 'CD', 'GQ', 'GA', 'ST', 'BI', 'KM', 'DJ', 'ER', 'ET', 'KE',
    'MG', 'MW', 'MU', 'MZ', 'RW', 'SC', 'SO', 'SS', 'TZ', 'UG', 'BW', 'SZ', 'LS', 'NA',
    'ZA', 'ZM', 'ZW', 'IN', 'PK', 'BD', 'HT', 'AF', 'AL', 'AM', 'AZ', 'KH', 'CU', 'DO',
    'FR', 'PF', 'GP', 'GY', 'IR', 'IQ', 'JM', 'JO', 'KZ', 'KI', 'KP', 'XK', 'KW', 'KG',
    'LA', 'YT', 'FM', 'MM', 'NP', 'CY', 'OM', 'PS', 'PG', 'BL', 'MF', 'PM', 'SY', 'TJ',
    'TR', 'TM', 'UZ', 'WF', 'YE'];
  public toolTipText = `”D’après nos données sur les impayées, cet utilisateur représente un risque financier important,
  Demander une caution VISALE, (caution gratuite réservée, aux mois de 30 ans et ceux vivant déjà en Europe).
  Si pas éligible: Garantme/Smartgarant, une réduction sur les frais Livinfrance peut lui être proposée pour compenser l’achat de ces garanties payantes”`;

  private $unsub;
  public documentUploadStatus: string = 'Envoi de la caution';
  public isLoadingCaution: boolean = false;
  public windowTopScrolled = false;
  public windowBottomScrolled = true;
  private scrollPercentage: number;
  currentLanguage: string;
  public isProd = environment.production;


  constructor(
    private careService: PropertiesService,
    private careService2: CareService,
    private modalService: NgbModal,
    private userService: UserService,
    private alertService: AlertService,
    private adminUserService: AdminUserService,
    private adminProcessService: AdminProcessService,
    private carePropertiesService: PropertiesService,
    private translate: TranslateService,
    private adminDocumentService: AdminDocumentsService,
    private fb: UntypedFormBuilder,
    private helperService: HelperService,
    private platformService: PlatformService,
    private localSettings: LocalSettingsService,
    private exportCsvService: ExportCsvService
  ) {
  }


  ngOnInit(): void {

    this.localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );


    this.isLoading = true;
    const margingLayout = document.getElementsByClassName('page_content')[0];
    margingLayout.classList.add('my-0');
    const $allBooking = this.careService.getBookings();
    const $filterContent = this.careService.getBookingFilters();
    forkJoin([$allBooking, $filterContent]).subscribe(results => {
      this.allBookings = results[0];
      this.agentList = results[1].agents;
      this.agentList.sort((a, b) => a.lastname.localeCompare(b.lastname));
      this.partnerList = results[1].partners;
      if (results[1].metropoles) {
        results[1].metropoles.forEach(metropole => {
          if (metropole.isHousingCity == 1) {
            this.metropoleList.push({label: metropole.name, value: metropole.name});
          }
        });
      }
      this.doFilter('init');
    }, (error) => {
      this.alertService.openSnackBar('Erreur au chargement, criez plz', 'snack-error');
    });
  }

  ngAfterViewInit(){
    if(this.platformService.isBrowserPlatform()){
      const page_listener = document.querySelector('.page_listener');
      page_listener.addEventListener('scroll', () => {
        this.windowTopScrolled = page_listener.scrollTop !== 0;
        const scrollHeight = page_listener.scrollHeight;
        const clientHeight = page_listener.clientHeight;
        this.scrollPercentage = (page_listener.scrollTop / (scrollHeight - clientHeight)) * 100;
        this.windowBottomScrolled = this.scrollPercentage !== 100;

      });
    }
  }

  ngOnDestroy(): void {
    const margingLayout = document.getElementsByClassName('page_content')[0];
    margingLayout.classList.remove('my-0');
  }

  public trackById(index, item): number {
    return item.id;
  }

  public trackByIndex(index): number {
    return index;
  }

  public isNationalityInList(nationality): boolean {
    if (nationality) {
      return this.nationalityList.includes(nationality);
    }
    return false;
  }

  splitFilter(r) {
    if (r) {
      const rSplit = r.split('&');
      rSplit.forEach(param => {
        const paramSplit = param.split('=')[param.split('=').length - 1];
        if (param.includes('status')) {
          this.statutFC.setValue(paramSplit);
        }
        if (param.includes('dateStart')) {
          this.dateFC.setValue(paramSplit);
        }
        if (param.includes('dateEnd')) {
          this.dateEnd.setValue(paramSplit);
        }
        if (param.includes('dateExact')) {
          this.dateExact.setValue(paramSplit);
        }
        if (param.includes('createdAtStart')) {
          this.createdAtStart.setValue(paramSplit);
        }
        if (param.includes('createdAtEnd')) {
          this.createdAtEnd.setValue(paramSplit);
        }
        if (param.includes('createdAtExact')) {
          this.createdAtExact.setValue(paramSplit);
        }
        if (param.includes('partner')) {
          this.partnerFC.setValue(paramSplit);
        }
        if (param.includes('owner')) {
          this.contactFC.setValue(paramSplit);
        }
        if (param.includes('minDuration')) {
          this.minDurationFilter.setValue(paramSplit);
        }
        if (param.includes('city')) {
          this.metropoleFC.setValue(paramSplit);
        }
        if (param.includes('studentResidence')) {
          this.isStudentResidence.setValue(paramSplit);
          this.isStudentResidence.value;
        }
        if (param.includes('countdown')) {
          this.annulationFC.setValue(paramSplit);
        }
        if (param.includes('search')) {
          this.currentSearch = paramSplit;
          this.page = this.pageIndex = 0;
          this.perPage = 100;
        }
      });
    } else {
      this.clearFilter();
      this.statutFC.setValue('A traiter/En attente');
    }
    this.saveInLocal();
  }


  public doFilter(isInit?): void {
    this.isLoading = true;
    if (isInit) {
      const r = this.userService.getFromLocal('adminBookingFilter');
      this.splitFilter(r);
    } else {
      this.saveInLocal();
    }
    this.queryParams = this.userService.getFromLocal('adminBookingFilter');
    this.refreshBooking();
  }

  public filter(type): void {
    if (type == this.filterType) {
      if (this.filterDirection == 'asc') {
        this.filterDirection = 'desc';
      } else {
        this.filterDirection = 'asc';
        this.filterType = null;
      }
    } else {
      this.filterType = type;
      this.filterDirection = 'asc';
    }

    if (this.filterType) {
      if (this.filterType == 'username') {
        this.bookings.sort((a, b) => (a.user && a.user.lastname && b.user && b.user.lastname ? (a.user.lastname.toUpperCase() < b.user.lastname.toUpperCase() ? -1 : 1) : 1) * (this.filterDirection == 'asc' ? 1 : -1));
      }
      if (this.filterType == 'email') {
        this.bookings.sort((a, b) => (a.user && a.user.email && b.user && b.user.email ? (a.user.email.toUpperCase() < b.user.email.toUpperCase() ? -1 : 1) : 1) * (this.filterDirection == 'asc' ? 1 : -1));
      }
      if (this.filterType == 'room') {
        this.bookings.sort((a, b) => (a.property && a.property.name && b.property && b.property.name ? (a.property.name.toUpperCase() < b.property.name.toUpperCase() ? -1 : 1) : 1) * (this.filterDirection == 'asc' ? 1 : -1));
      }
      if (this.filterType == 'date') {
        this.bookings.sort((a, b) => (a.created_at > b.created_at ? -1 : 1) * (this.filterDirection == 'asc' ? 1 : -1));
      }
      if (this.filterType == 'partner') {
        this.bookings.sort((a, b) => {
          a.property = this.compareIfNothing(a, 'property', 'partner', 'name');
          b.property = this.compareIfNothing(b, 'property', 'partner', 'name');
          return (a.property && a.property.partner && b.property && b.property.partner ? (a.property.partner.name.toUpperCase() < b.property.partner.name.toUpperCase() ? -1 : 1) : 1) * (this.filterDirection == 'asc' ? 1 : -1);
        });
      }
      if (this.filterType == 'contact') {
        this.bookings.sort((a, b) => {
          a.user = this.compareIfNothing(a, 'user', 'agent', 'firstname');
          b.user = this.compareIfNothing(b, 'user', 'agent', 'firstname');
          return (a.user && a.user.agent && b.user && b.user.agent ? (a.user.agent.firstname.toUpperCase() < b.user.agent.firstname.toUpperCase() ? -1 : 1) : 1) * (this.filterDirection == 'asc' ? 1 : -1);
        });
      }
      if (this.filterType == 'duration') {
        this.bookings.sort((a, b) => {
            const durationA = this.calculateTotalLocation(a);
            const durationB = this.calculateTotalLocation(b);
            return (durationA - durationB) * (this.filterDirection == 'asc' ? 1 : -1);
        });
    }
    } else {
      this.bookings.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
    }
    this.paginateBooking();
  }

  public refreshBooking(magic?): void {
    this.isLoading = true;
    if (this.$unsub) {
      this.$unsub.unsubscribe();
    }
    this.$unsub = this.careService.getAllBookings(this.page, this.perPage, this.queryParams, magic).pipe(
      first(),
      finalize(() => {
        this.$unsub = null;
      })
    ).subscribe(response => {
      this.displayedBookings = [];
      this.setBookings(response);
      this.isLoading = false;
    }, (error) => {
      this.alertService.openSnackBar('Erreur à la récupération des bookings', 'snack-error');
    });
  }

  public rapidSearch(search, typeFilter?) {
    this.queryParams = JSON.parse(JSON.stringify(this.parseFilter(search)));
    this.refreshBooking(typeFilter);
  }

  public openCalendar(calendar, type): void {
    this.dateType = type;
    this.modalService.open(calendar, {centered: true, size: 'lg'});
  }

  public setForceDate(date, type) {
    if (date) {
      if (type == 'end') {
        this.dateEnd.setValue(date.year + '-' + date.month + '-' + date.day);
      }
      if (type == 'dateExact') {
        this.dateExact.setValue(date.year + '-' + date.month + '-' + date.day);
      }
      if (type == 'start') {
        this.dateFC.setValue(date.year + '-' + date.month + '-' + date.day);
      }
      if (type == 'createdAtStart') {
        this.createdAtStart.setValue(date.year + '-' + date.month + '-' + date.day);
      }
      if (type == 'createdAtExact') {
        this.createdAtExact.setValue(date.year + '-' + date.month + '-' + date.day);
      }
      if (type == 'createdAtEnd') {
        this.createdAtEnd.setValue(date.year + '-' + date.month + '-' + date.day);
      }
    } else {
      this.modalService.dismissAll();
      if (type == 'end' || type == 'clear') {
        this.dateEnd.setValue(null);
      }
      if (type == 'dateExact' || type == 'clear') {
        this.dateExact.setValue(null);
      }
      if (type == 'start' || type == 'clear') {
        this.dateFC.setValue(null);
      }
      if (type == 'createdAtStart' || type == 'clear') {
        this.createdAtStart.setValue(null);
      }
      if (type == 'createdAtExact' || type == 'clear') {
        this.createdAtExact.setValue(null);
      }
      if (type == 'createdAtEnd' || type == 'clear') {
        this.createdAtEnd.setValue(null);
      }
      this.doFilter();
    }

  }

  public clearSpecificFilters(filter): void {
    switch (filter) {
      case 'dates': {
        this.dateFC.patchValue(null);
        this.dateEnd.patchValue(null);
        this.dateExact.patchValue(null);
        break;
      }
      case 'createdAt': {
        this.createdAtStart.patchValue(null);
        this.createdAtEnd.patchValue(null);
        this.createdAtExact.patchValue(null);
        break;
      }
      case 'validatedAt' : {
        this.validatedAtValues = {choice: 'at', min: null, max: null,};
        this.validatedAtFC.patchValue(null);
        break;
      }
    }
  }

  public setStateFilter(value) {
    this.statutFC.setValue(value);
    if (this.statutFC.value !== 'A traiter/En attente') {
      this.annulationFC.patchValue(null);
      this.pendingFC.patchValue(null);
    }
    this.hasChangedFilter = true;
    this.doFilter();
  }

  openSideBox(open, element?): void {
    this.userCountry = null;
    this.isModalOpen = false;
    if (element !== this.booking) {
      this.booking = element;
      if (element.property.property_photos && element.property.property_photos.length > 0) {
        const cover_photo = element.property.property_photos.find(x => x.cover_photo == 1);
        if (cover_photo) {
          this.booking['cover_photo'] = cover_photo.photo;
        }
      }
      this.booking.care_notif = 0;
      if (this.booking.user && this.booking.user.country) {
        this.translate.get('COUNTRIES.' + this.booking.user.country).subscribe(async (value) => {
          this.userCountry = value;
        });
      }
      this.isModalOpen = open;
      this.checkDocuments();
    } else {
      this.closeSideBox();
    }
  }

  refreshSideBox(element) {
    const booking = this.bookings.find(booking => booking.id === this.booking.id);
    this.userCountry = null;
    this.booking = booking;
    if (booking.property.property_photos && booking.property.property_photos.length > 0) {
      const cover_photo = element.property.property_photos.find(x => x.cover_photo == 1);
      if (cover_photo) {
        this.booking['cover_photo'] = cover_photo.photo;
      }
    }
    this.booking.care_notif = 0;
    if (this.booking.user && this.booking.user.country) {
      this.translate.get('COUNTRIES.' + this.booking.user.country).subscribe(async (value) => {
        this.userCountry = value;
      });
    }
    this.checkDocuments();
  }

  closeSideBox() {
    this.isModalOpen = false;
    this.booking = null;
    this.idPhoto = null;
    this.lettreAdmisssion = null;
    this.userCountry = null;
  }

  download() {
    window.open(this.pdfItem);

  }

  checkDocuments() {
    this.idPhoto = this.lettreAdmisssion = this.attestationLogement = this.caution = this.booking_invoice = null;
    if (this.booking && this.booking.user && this.booking.user.documents) {
      this.caution = this.booking.user.documents.find(doc => doc.pivot.id === this.booking.caution_id);
      this.attestationLogement = this.booking.user.documents.find(doc => doc.pivot.id === this.booking.attestation_id);
      this.booking.user.documents.forEach(element => {
        if (element.key == 'ID_PHOTO') {
          this.idPhoto = element;
        }
        if (element.key == 'LETTRE_D_ADMISSION') {
          this.lettreAdmisssion = element;
        }
        if (element.key == 'INV_BK') {
          this.booking_invoice = element;
        }
      });
    }
  }

  goToDocument(document) {
    if (document) {
      window.open(this.rawMediaURL + document.pivot.path + document.pivot.filename, '_blank');
    }
  }

  goTo(page: string) {
    if (page === 'stripe') {
      window.open('https://dashboard.stripe.com/payments/' + this.booking.transaction_id, '_blank');
    }
    if (page === 'user') {
      const url = window.location.protocol + '//' + window.location.host;
      window.open(url + '/admin/users/' + this.booking.user.id, '_blank');
    }
  }

  openModal(content, type) {
    let size = null;
    this.searchText = null;
    this.selectedRooms = [];
    this.isLoading = true;
    this.additionalAddressFormControl = new UntypedFormControl(this.booking.user.homeAdditionalAddress);
    if (type == 'validate') {
      size = 'lg';
    }


    this.getAddressInfos().pipe(
      first(),
      finalize(() => {
        this.setForm();
      })
    ).subscribe(data => {
      this.booking.user['homeCity_Info'] = data[0];
      this.booking.user['homeCountry_Info'] = data[1];
    });

    this.modalService.open(content, {size: size, centered: true});
  }

  calculateAge() {
    const timeDiff = Math.abs(Date.now() - new Date(this.booking.user.birthdate).getTime());
    return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  }

  refuseBooking(userId, bookingId, selectedReason) {
    this.isLoading = true;
    this.adminProcessService.refuseBooking(bookingId, selectedReason)
      .subscribe({
        next: () => {
          this.refreshBooking();
          this.isLoading = false;
          this.closeAndAlert('Le booking a bien été refusé.', 'snack-success');
        },
        error: (error) => {
          this.closeAndAlert(error, 'snack-error');
        },
        complete: () => {
          let hubspotDatas = {
            user_id:userId,
            campagne: '',
            source: '',
            medium: ''
          };

          this.adminUserService.setHubspotDealFromCare(3321704, 11339151, hubspotDatas).subscribe();        }
      });
  }

  endBooking() {
    this.carePropertiesService.closeBooking(this.booking.id).subscribe(() => {
      this.closeAndAlert('Booking clôturé avec succès', 'snack-success');

    });
  }

  public updateUser(): void {
    this.isUpdatingBooking = true;
    if (this.birthdateComponent) {
      this.birthdateComponent.yearControl.markAsTouched();
      this.birthdateComponent.monthControl.markAsTouched();
      this.birthdateComponent.dayControl.markAsTouched();
    }
    Object.keys(this.form.controls).forEach(c => {
      this.form.controls[c].markAsTouched();
    });
    if (this.form.valid && this.isBirthdayCorrect) {
      this.userService.update({
        id: this.booking.user.id,
        firstname: this.form.value.firstname,
        lastname: this.form.value.lastname,
        phone: this.form.value.phone.internationalNumber,
        email: this.form.value.email,
        birthdate: this.form.value.birthdate,
        birthplace: this.form.value.birthplace,
        agent_id: this.form.value.agent.id,
        birthCountry: this.birthCountry,
        homeAddress: (this.userFormattedAddress['number'] ? this.userFormattedAddress['number'] + ' ' : '') + this.userFormattedAddress['route'],
        fullHomeAddress : (this.userFormattedAddress['number'] ? this.userFormattedAddress['number'] + ' ' : '') + this.userFormattedAddress['route'] + ' ' + this.userFormattedAddress['postal_code'],
        city_id: this.userFormattedAddress['city'] ? (typeof this.userFormattedAddress['city'] === 'number' ? this.userFormattedAddress['city'] : this.userFormattedAddress['city'].id) : null,
        homeAdditionalAddress: this.userFormattedAddress['additional'] ? this.userFormattedAddress['additional'] : this.additionalAddressFormControl.value,
        postalCode: this.userFormattedAddress['postal_code'],
        country: this.userFormattedAddress['country'],
      }).pipe(first()).subscribe({
        next: (data: any) => {
        },
        error: (error) => {
          this.alertService.openSnackBar('Une erreur s\'est produite lors de la mise à jour de l\'utilisateur.', 'snack-error');
          this.isUpdatingBooking = false;
        },
        complete: () => {
          this.careService.updateBooking(this.booking.id, {
            start_date: this.form.value.start_date,
            end_date: this.form.value.end_date,
            property_id: this.form.value.property_id,
            status: this.form.value.status,
          }).subscribe({
            next: (response: any) => {
              if (response.status === 'success') {
                this.canSend = true;
                this.isModif = false;
                this.updateABookingDatas(response.booking);
                this.booking = response.booking;
                const bookingIndex: number = this.displayedBookings.findIndex(b => b.id === this.booking.id);
                this.displayedBookings[bookingIndex] = this.booking;
                this.checkDocuments();
                this.alertService.openSnackBar('Informations mises à jour.', 'snack-success');
              } else {
                this.alertService.openSnackBar('Une erreur s\'est produite lors de la mise à jour de la réservation.', 'snack-error');
              }
            },
            error: (error) => {
              this.alertService.openSnackBar(error, 'snack-error');
            },
            complete: () => {
              this.isUpdatingBooking = false;
            }
          });
        }
      });
    } else {
      this.alertService.openSnackBar('Veuillez remplir correctement tous les champs obligatoires.', 'snack-error');
      this.isUpdatingBooking = false;
    }
  }

  public sendBooking() {
    this.validateBooking(this.booking.user.id, this.booking.id);
    this.closeAndAlert('Booking validé', 'snack-success');
    this.getFilterStates();
    this.canSend = false;
    this.modalService.dismissAll();
  }

  public cancelChanges(): void {
    if (this.form.value.phone && this.form.value.phone.internationalNumber) {
      this.form.value.phone = this.form.value.phone.internationalNumber;
    }
    if (!this.form.controls[this.editingItem].errors) {
      this.editingItem = null;
    }
  }

  public setInfos(event: any, type: string): void {
    switch (type) {
      case 'birthdate': {
        this.checkDate(event, this.form.controls.birthdate);
        break;
      }
      case 'formattedAddress': {
        this.displayedAddress = '';
        this.userFormattedAddress = event;
        if (event['number']) {
          this.displayedAddress = this.userFormattedAddress['number'] + ' ';
        }
        this.displayedAddress += this.userFormattedAddress['route'] + ', ' + event['postal_code'] + ' ' + (event['city'] ? event['city'].name + ', ' : '') + event['country'];
        this.form.controls.address.setValue(this.displayedAddress);
        break;
      }
      case 'city': {
        if (event.formatted_address) {
          const split = event.formatted_address.split(', ');
          this.birthCountry = split[split.length - 1];
          split.splice(split.length - 1, 1);
          this.form.controls.birthplace.setValue(split.join(', '));
        }
        break;
      }
      case 'add': {
        this.userFormattedAddress['additional'] = ' ' + event;
        break;
      }
    }
  }

  public leaveNote(modale, booking): void {
    this.currentBooking = booking;
    this.formNote = this.fb.group({
      content: [booking.note],
    });
    this.modalService.open(modale, {size: 'sm', centered: true});
  }

  public changeDoc(modale): void {
    this.modalService.open(modale, {size: 'lg', centered: true});
  }

  public sendNote(booking): void {
    if (!booking) {
      booking = this.currentBooking;
    }
    this.isSending = true;
    this.careService.addNoteToBooking({id: booking.id, note: this.formNote.value.content}).pipe(first()).subscribe((data: any) => {
      this.isSending = false;
      if (data.status == 'success') {
        booking.note = this.formNote.value.content;
        this.modalService.dismissAll();
        this.alertService.openSnackBar('Note mise à jour correctement', 'snack-success');
      } else {
        this.alertService.openSnackBar('Un problème est suvenu, la note n\'a pas pu être laissée', 'snack-error');
      }

    });
  }

  private calculateDiff(dateDispo, dateBooking) {
    dateBooking = new Date(dateBooking);
    dateDispo = new Date(dateDispo);
    const today = new Date();

    if (dateDispo < today) {
      dateDispo = today;
    }

    const utcBook = Date.UTC(dateBooking.getFullYear(), dateBooking.getMonth(), dateBooking.getDate());
    const utcDisp = Date.UTC(dateDispo.getFullYear(), dateDispo.getMonth(), dateDispo.getDate());
    const diff = Math.floor((utcBook - utcDisp) / (1000 * 60 * 60 * 24));

    if (diff > 0) {
      if (diff === 1) {
        return diff + ' jour';
      }
      return diff + ' jours';
    }
    return '0 jour';
  }

  printStatus(status, pending_reason) {

    if (status == 'Pending' && pending_reason == null) {
      return ('Nouveau');
    }
    if (status == 'Pending' && pending_reason) {
      return ('En attente');
    }
    if (status == 'Accepted') {
      return ('En cours');
    }
    if (status == 'Cancelled') {
      return ('Annulé');
    }
    if (status == 'Expired') {
      return ('Terminé');
    }
    if (status == 'Declined') {
      return ('Refusé');
    }
    return 'N/A';

  }

  clearFilter() {
    if (this.isRapidFilter === 'None') {
      this.filter('');
      this.currentSearch = '';
    }
    this.partnerFC.setValue(null);
    this.contactFC.setValue(null);
    this.metropoleFC.setValue(null);
    this.statutFC.setValue(null);
    this.dateFC.setValue(null);
    this.dateEnd.setValue(null);
    this.dateExact.setValue(null);
    this.sortFC.setValue(null);
    this.createdAtStart.setValue(null);
    this.createdAtEnd.setValue(null);
    this.createdAtExact.setValue(null);
    this.annulationFC.setValue(null);
    this.isRapidFilter = 'None';
    this.validatedAtFC.patchValue(null);
    this.minDurationFilter.setValue(null);
    this.isStudentResidence.setValue(null);
    this.isInNationalityList.setValue(null);
    this.validatedAtValues = {
      choice: 'at',
      min: null,
      max: null
    };
  }

  clearAll() {
    this.clearFilter();
    this.doFilter();
  }

  getWhatsAppLink(number) {
    if (number) {
      let format = number.replace(/[^0-9]/g, '');
      return 'https://api.whatsapp.com/send?phone=' + format;
    }
    return false;
  }

  returnUrl(element) {
    if (!element.redirect) {
      return window.location.protocol + '//' + window.location.host + '/accommodation/property/' + element.id;
    }
    return element.link;
  }

  getPaymentLink(bookingId) {
    this.loadingPayment = true;
    this.careService.getPaymentLink(bookingId).subscribe(data => {
      this.loadingPayment = false;
      if (data.toString().includes('stripe') || this.isProd) {
        window.open(data.toString(), '_blank');
      } else {
        if (!this.isProd) {
          const dataSplit = data.toString().split('/');
          const id = dataSplit[dataSplit.length - 1];
          window.open('https://www.sandbox.paypal.com/unifiedtransactions/details/payment/'+ id, '_blank');
        }
      }
    });
  }

  openOption(id: number) {
    this.selectedBookingId = id;
    this.isOptionOpened = !this.isOptionOpened;
  }

  closeOption(booking, reason: string) {
    booking.isBusy = true;
    this.adminProcessService.setBookingPendingReason(this.selectedBookingId, reason).subscribe(() => {
      booking.pending_reason = reason;
      booking.isBusy = false;
    });
    this.selectedBookingId = null;

  }

  shareBooking(bookingId: number) {
    this.isLoading = true;
    this.careService2.shareBooking(bookingId).subscribe(() => {
      this.alertService.openSnackBar('Le booking a bien été partagé.', 'snack-success');
      this.isLoading = false;
    });
  }

  resendInfoToPartners(bookingId: number) {
    this.isLoading = true;
    this.careService2.resendInfoToPartners(bookingId).subscribe(() => {
      this.alertService.openSnackBar('Les informations ont bien été renvoyées.', 'snack-success');
      this.isLoading = false;
    });
  }

  private getHoursUntilCancellation(createdAt: string): number {
    const countdownStartDate = new Date(createdAt);
    countdownStartDate.setDate(countdownStartDate.getDate() + 4); // Start countdown 4 days after creation
    const countdownEndDate = new Date(countdownStartDate);
    countdownEndDate.setDate(countdownEndDate.getDate() + 3); // Countdown lasts for 3 days
    const now = new Date();
    if (now < countdownStartDate) {
      return null; // Countdown has not started yet
    } else if (now > countdownEndDate) {
      return 0; // Countdown has ended
    } else {
      const diffInMilliseconds = countdownEndDate.getTime() - now.getTime();
      return Math.floor(diffInMilliseconds / (1000 * 60 * 60)); // Countdown is ongoing
    }
  }

  public paginateBooking(e?): void {
    this.displayedBookings = [];
    if (this.bookings) {
      this.displayedBookings = this.bookings.slice(0, this.perPage);
    }
  }

  public paginate(e?): void {
    if (e) {
      this.isLoading = true;
      this.page = e.pageIndex;
      if (this.perPage !== e.pageSize) {
        this.page = 0;
      }
      this.perPage = e.pageSize;
    }
    this.refreshBooking();
  }

  toNumber(string) {
    return parseFloat(string);
  }

  getFilterStates(): any {
    return {
      statut: this.statutFC.value,
      annulation: this.annulationFC.value,
      contact: this.contactFC.value,
      metropole: this.metropoleFC.value,
      studentResidence: this.isStudentResidence.value,
      partner: this.partnerFC.value,
      date: this.dateFC.value,
      dateEnd: this.dateEnd.value,
      dateExact: this.dateExact.value,
      createdAtStart: this.createdAtStart.value,
      createdAtEnd: this.createdAtEnd.value,
      createdAtExact: this.createdAtExact.value,
    };
  }

  parseFilter(rapidSearch?) {
    let filterString = '';
    if (this.statutFC.value) {
      filterString += 'status=' + this.statutFC.value + '&';
    }
    if (this.pendingFC.value) {
      filterString += 'pendingReason=' + this.pendingFC.value + '&';
    }
    if (this.partnerFC.value) {
      filterString += 'partner=' + this.partnerFC.value + '&';
    }
    if (this.contactFC.value) {
      filterString += 'owner=' + this.contactFC.value + '&';
    }
    if (this.minDurationFilter.value) {
      filterString += 'minDuration=' + this.minDurationFilter.value + '&';
    }
    if (this.metropoleFC.value) {
      filterString += 'city=' + this.metropoleFC.value + '&';
    }
    if (this.isStudentResidence.value !== null) {
      filterString += 'studentResidence=' + this.isStudentResidence.value + '&';
  }
    if (this.dateFC.value) {
      filterString += 'dateStart=' + this.dateFC.value + '&';
    }
    if (this.dateEnd.value) {
      filterString += 'dateEnd=' + this.dateEnd.value + '&';
    }
    if (this.dateExact.value) {
      filterString += 'dateExact=' + this.dateExact.value + '&';
    }
    if (this.createdAtStart.value) {
      filterString += 'createdAtStart=' + this.createdAtStart.value + '&';
    }
    if (this.createdAtEnd.value) {
      filterString += 'createdAtEnd=' + this.createdAtEnd.value + '&';
    }
    if (this.createdAtExact.value) {
      filterString += 'createdAtExact=' + this.createdAtExact.value + '&';
    }
    if (this.currentSearch.length !== 0) {
      filterString += 'search=' + this.currentSearch + '&';
      this.page = this.pageIndex = 0;
      this.perPage = 100;
    }
    if (this.annulationFC.value) {
      filterString += 'countdown=' + this.annulationFC.value + '&';
    }
    if (this.validatedAtFC.value) {
      filterString += 'validatedAt=';
      if (this.validatedAtFC.value === 'custom') {
        filterString += this.validatedAtValues.choice + '-' + this.validatedAtValues.min + (this.validatedAtValues.max ? 'to' + this.validatedAtValues.max : '');
      } else {
        filterString += this.validatedAtFC.value;
      }
      filterString += '&';
    }
    if (rapidSearch) {
      filterString = 'status=A traiter/En attente&';
      filterString += 'search=' + rapidSearch + '&';
    }

    return filterString;
  }

  private saveInLocal(): void {
    const filterString = this.parseFilter();
    this.userService.storeInLocal('adminBookingFilter', filterString);
  }

  public generateCaution(userId: number, bookingId: number): void {
    this.isLoadingCaution = true;
    this.adminDocumentService.generateCaution(userId, bookingId).subscribe({
      next: (response: any) => {
        this.alertService.openSnackBar('Nouvelle caution générée', 'snack-success');
        // Met à jour le booking affiché & dans la liste des bookings
        this.updateABookingDatas(response.booking);
        this.booking = response.booking;
        const bookingIndex: number = this.displayedBookings.findIndex(b => b.id === this.booking.id);
        this.displayedBookings[bookingIndex] = this.booking;
        this.checkDocuments();
      },
      error: (error) => {
        this.isLoadingCaution = false;
        this.alertService.openSnackBar('Erreur à la génération de la caution', 'snack-error');
      },
      complete: () => {
        this.isLoadingCaution = false;
        this.modalService.dismissAll();
      }
    });
  }

  private compareIfNothing(mainElement, element1, element2?, element3?): any {
    if (!mainElement[element1]) {
      mainElement[element1] = {};
    }
    if (!mainElement[element1][element2]) {
      mainElement[element1][element2] = {};
      mainElement[element1][element2][element3] = 'ZZZ';
    }
    return mainElement[element1];
  }

  onUpload(event: any) {
    this.isLoadingCaution = true;
    this.booking.user.documents.push({type: event.documentType, pivot: event.name});
    // Gestion de l'upload d'une caution
    if (event && event.documentType === 'CTNMNT') {
      this.documentUploadStatus = 'Assignation de la caution au booking';
      this.adminProcessService.updateBookingDocuments(this.booking.id, event.name.id, event.documentType, this.cautionType.value).subscribe({
        next: (response: any) => {
          // Met à jour les documents du booking
          this.booking = response.booking;
          const bookingIndex: number = this.displayedBookings.findIndex(b => b.id === this.booking.id);
          this.displayedBookings[bookingIndex] = this.booking;
          this.checkDocuments();
        },
        error: (error) => {
          this.isLoadingCaution = false;
          this.alertService.openSnackBar('Y a un couac, criez plz', 'snack-error');
        },
        complete: () => {
          this.isLoadingCaution = false;

          this.alertService.openSnackBar('Caution mise à jour', 'snack-success');
        }
      });

    }

  }

  setValidatedAtValues(e, range: string): void {
    const lang = localStorage.getItem('language');
    if (range === 'min') {
      if (lang === 'en') {
        const split = e.startdate.split('/');
        this.validatedAtValues.min = split[1] + '/' + split[0] + '/' + split[2];
      } else {
        this.validatedAtValues.min = e.startdate;
      }
    } else {
      if (lang === 'en') {
        const split = e.enddate.split('/');
        this.validatedAtValues.max = split[1] + '/' + split[0] + '/' + split[2];
      } else {
        this.validatedAtValues.max = e.enddate;
      }
    }
  }

  private setBookingAndVars(data) {
    this.agentList.forEach(a => {
      a.sum = 0;
    });
    data.forEach(d => {
      this.updateABookingDatas(d);
    });
    this.bookings = data;
    this.isLoading = false;
    this.hasChangedFilter = false;
    this.paginateBooking();
  }

  private closeAndAlert(msg: string, snkClass: string): void {
    //appeller le refresh des bookings
    this.closeSideBox();
    this.modalService.dismissAll();
    this.alertService.openSnackBar(msg, snkClass);
  }

  private getAgentInfo(agentId: number): any {
    const agent = this.agentList.find(agent => agent.id === agentId);
    return agent ? agent : null;
  }

  private setForm(): void {
    const address = this.userService.formatHomeAddress(this.booking.user);
    this.displayedAddress = address;

    this.birthCountry = this.booking.user.birthCountry;
    this.userFormattedAddress = {
      route: this.booking.user.homeAddress,
      postal_code: this.booking.user.postalCode,
      city_id: this.booking.user.homeCity_id,
      country: this.booking.user.country,
    };
    const agentId = this.booking.user.agent_id ? this.booking.user.agent_id : 20;
    this.form = this.fb.group({
      firstname: [this.booking.user.firstname, Validators.required],
      lastname: [this.booking.user.lastname, Validators.required],
      phone: [this.booking.user.phone, Validators.required],
      email: [this.booking.user.email, Validators.required],
      address: [address, Validators.required],
      birthdate: [this.booking.user.birthdate, Validators.required],
      birthplace: [this.booking.user.birthplace, Validators.required],
      start_date: [this.booking.start_date, Validators.required],
      end_date: [this.booking.end_date, Validators.required],
      property_id: [this.booking.property_id, Validators.required],
      agent: [this.getAgentInfo(agentId), Validators.required],
      status: [this.booking.status, Validators.required],
    });
    this.isLoading = false;
  }

  private checkDate(event: any, fc: any): void {
    if (event.yearControl && event.monthControl && event.dayControl) {
      const dateCheck = new Date(event.yearControl, event.monthControl - 1, event.dayControl);
      if (dateCheck.getFullYear() != event.yearControl || (dateCheck.getMonth() + 1) != event.monthControl || dateCheck.getDate() != event.dayControl) {
        this.isBirthdayCorrect = false;
      } else {
        this.isBirthdayCorrect = true;
        fc.setValue(dateCheck.getFullYear() + '-' + (dateCheck.getMonth() + 1) + '-' + dateCheck.getDate());
      }
    }
  }

  private setBookings(data): void {
    this.bookings = data.data.data;
    if (this.booking != null) {
      this.refreshSideBox(this.booking);
    }

    if (this.isInNationalityList.value !== null) {
      this.bookings = this.bookings.filter(booking => {
        //faire le test direct en back
          const nationalityStatus = this.isNationalityInList(booking.user?.nationality);
          return this.isInNationalityList.value ? nationalityStatus : !nationalityStatus;
      });






      this.totalBookings = this.bookings.length;
    } else {

      this.totalBookings = data.total;
    }

    this.LFFees = data.fees;
    this.setBookingAndVars(this.bookings);
}

  onDelete(event: any) {
    console.log('Attachment deleted:', event);
  }

  private validateBooking(userId: number, bookingId: number, partnerDate?: any): void {
    const today = new Date();
    const bookingStartDate = new Date(this.booking.start_date);
    const diffTime = Math.abs(bookingStartDate.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    this.adminProcessService.validateBooking({bookingId: bookingId, partnerAnswer: partnerDate})
      .subscribe({
        next: () => {
          let hubspotDatas = {
            user_id:userId,
            campagne: '',
            source: '',
            medium: ''
          };

          this.adminUserService.setHubspotDealFromCare(3321704, 11333145,hubspotDatas).subscribe();

          this.refreshBooking();
          this.alertService.openSnackBar('Le booking a bien été validé.', 'snack-success');
          this.isButtonDisabled = null;
          if (diffDays <= 7) {
            this.alertService.openSnackBarWarn(
              'Attention, la réservation commence dans moins de 7 jours. Pensez à suivre la réception du bail et des paiements de l’utilisateur',
              'snack-warning'
            );
          }
        },
        error: (error) => {
          this.isButtonDisabled = null;
          this.alertService.openSnackBar(error, 'snack-error');
        },
        complete: () => {
        }
      });
  }





  /**
   * Get user's city & country information.
   * @private
   */
  private getAddressInfos(): Observable<any> {
    const cityInfo = from([this.userService.getCityById(this.booking.user.homeCity_id)]);
    const countryInfo = from([this.userService.getCountry(this.booking.user.country)]);
    return forkJoin([cityInfo, countryInfo]).pipe(
      map(([cityInfo, countryInfo]) => [cityInfo, countryInfo])
    );
  }

  rapidFilter(typeFilter, filterValue) {
    if (this.isRapidFilter !== typeFilter && this.isRapidFilter === 'None') {
      this.oldFilter = this.userService.getFromLocal('adminBookingFilter');
      this.clearFilter();
      this.isRapidFilter = typeFilter;
      this.statutFC.setValue('A traiter/En attente');
      this.rapidSearch(filterValue, typeFilter);
    } else if (this.isRapidFilter !== typeFilter && this.isRapidFilter !== 'None') {
      this.clearFilter();
      this.isRapidFilter = typeFilter;
      this.statutFC.setValue('A traiter/En attente');
      this.rapidSearch(filterValue, typeFilter);
    } else {
      this.isRapidFilter = 'None';
      this.queryParams = this.oldFilter;
      this.splitFilter(this.queryParams);
      this.refreshBooking();
    }
  }

  isBookingInList(propertyId: number): boolean {
    return this.allBookings['property_id'].some(b => b === propertyId);
  }
  isHousingIdInList(houseId: any): boolean {
    return this.allBookings['house_id'].some(b => b == houseId);
  }


  isUserInList(userId: number): boolean {
    return this.allBookings['user_id'].some(b => b === userId);
  }

  onMetropoleChange(e) {
    this.hasChangedFilter = true;
    if (this.isRapidFilter === 'None') {
      this.doFilter();
    }
  }

  /**
   * Met en forme les datas nécessaire à l'affichage des bookings
   * @param booking
   * @private
   */
  private updateABookingDatas(booking) {
    if (booking.user && booking.user.agent) {
      const index = this.agentList.findIndex(a => a.id === booking.user.agent.id);
      this.agentList[index].sum += 1;
    }
    if (booking.postReservationDatas && booking.postReservationStepId && booking.postReservationStepId !== 'null') {
      if (booking.postReservationStepId == 255) {
        booking.currentStep = booking.postReservationDatas[booking.postReservationDatas.length - 1];
      } else {
        booking.currentStep = booking.postReservationDatas.find(pr => pr.id == booking.postReservationStepId);
      }
    }
    // Set user avatar
    if (!booking.user || (booking.user && (!booking.user.avatar || booking.user.avatar === 'default-avatar.png'))) {
      booking.displayedAvatar = 'N/A';
      if (booking.user) {
        booking.displayedAvatar = booking.user.firstname[0] + booking.user.lastname[0];
      }
    }

    // Set agent avatar
    booking.agentDisplayedAvatar = '/assets/img/admin/agents/';
    if (booking.user && booking.user.agent) {
      booking.agentDisplayedAvatar += (booking.user.agent.firstname.normalize('NFD').replace(/[\u0300-\u036f]/g, '')).toLowerCase() + '.webp';
    } else {
      booking.agentDisplayedAvatar += 'alban.webp';
    }

    if (booking.property) {
      booking['dateDiff'] = this.calculateDiff(booking.property['disponibility'], booking['start_date']);
    }

    if (booking.status === 'Pending') {
      booking['HoursUntilCancellation'] = this.getHoursUntilCancellation(booking['created_at']);
    }
  }

  scrollToTop(): void {
    const page_listener = document.querySelector('.page_listener');
    page_listener.scrollTo(0, 0);
  }

  scrollToBottom(): void {
    const page_listener = document.querySelector('.page_listener');
    const scrollHeight = page_listener.scrollHeight;
    page_listener.scrollTo(0, scrollHeight);
  }

calculateTotalLocation(booking): number {
  let start_date = new Date(booking.start_date);
  let end_date = new Date(booking.end_date);

  let yearsDiff = end_date.getFullYear() - start_date.getFullYear();
  let monthsDiff = end_date.getMonth() - start_date.getMonth();

  let totalMonths = yearsDiff * 12 + monthsDiff;


  let daysDiff = end_date.getDate() - start_date.getDate();

  let monthFraction = daysDiff / 30.0;
  let totalLocation = totalMonths + monthFraction;

  return Math.round(totalLocation * 10) / 10;
}


partnerMessage(booking: any) {

  const message = [
    `Nouvelle demande Livinfrance\n`,
    `Contact: ${booking.user.firstname} ${booking.user.lastname} - ${booking.user.city}`,
    `Date de naissance: ${booking.user.birthdate}`,
    `Lieu de naissance: ${booking.user.birthplace}`,
    `Arrivée (estimée): ${booking.start_date}`,
    `Départ (estimé): ${booking.end_date}`,
    `Ville du booking: ${booking.property.property_address.city}`,
    `Garantie: ${this.caution?.pivot?.type ? this.caution.pivot.type : 'LivinFrance'}`,
    `Lien: ${booking.property.link}`
  ].join('\n');

  navigator.clipboard.writeText(message)
    .then(() => {
      console.log('Copié dans le presse-papier !');
    })
    .catch(err => {
      console.error('Erreur lors de la copie :', err);
    });
}
public exportBookings(): void {
  // Désactive le mode pagination temporairement
  const tempPage = this.page;
  const tempPerPage = this.perPage;

  // Récupère tous les bookings
  this.careService.getAllBookings(0, this.totalBookings, this.queryParams).pipe(
    first()
  ).subscribe({
    next: (response) => {
      const headers = [
        'ID',
        'Statut',
        'Date de création',
        'Date de mise à jour',
        'Date de début',
        'Date de fin',
        'Durée (mois)',
        'ID Utilisateur',
        'Nom',
        'Prénom',
        'Email',
        'Téléphone',
        'Agent',
        'ID Logement',
        'Ref. Partenaire',
        'Nom logement',
        'Ville',
        'Code postal',
        'Partenaire',
        'Loyer mensuel',
        'Frais de réservation',
        'Mode paiement',
        'Note'
      ];

      const data = response.data.data.map(booking => ({
        'ID': booking.id,
        'Statut': this.printStatus(booking.status, booking.pending_reason),
        'Date de création': booking.created_at ? new Date(booking.created_at).toLocaleDateString() : '',
        'Date de mise à jour': booking.updated_at ? new Date(booking.updated_at).toLocaleDateString() : '',
        'Date de début': booking.start_date ? new Date(booking.start_date).toLocaleDateString() : '',
        'Date de fin': booking.end_date ? new Date(booking.end_date).toLocaleDateString() : '',
        'Durée (mois)': this.calculateTotalLocation(booking),
        'ID Utilisateur': booking.user?.id || '',
        'Nom': booking.user?.lastname || '',
        'Prénom': booking.user?.firstname || '',
        'Email': booking.user?.email || '',
        'Téléphone': booking.user?.phone || '',
        'Agent': booking.user?.agent?.firstname || '',
        'ID Logement': booking.property_id || '',
        'Ref. Partenaire': booking.property?.partner_ref || '',
        'Nom logement': booking.property?.name || '',
        'Ville': booking.property?.property_address?.city || '',
        'Code postal': booking.property?.property_address?.postal_code || '',
        'Partenaire': booking.property?.partner?.name || '',
        'Loyer mensuel': booking.per_month || '',
        'Frais de réservation': booking.reservation_fees || '',
        'Mode paiement': booking.transaction_mode || '',
        'Note': booking.note || ''
      }));

      // Exporte les données
      this.exportCsvService.exportToCsv(data, 'bookings-export', {
        headers: headers,
        delimiter: ';',
        includeHeaders: true
      });

      // Restaure les paramètres de pagination
      this.page = tempPage;
      this.perPage = tempPerPage;
      this.refreshBooking();
      this.isLoading = false;
    },
    error: (error) => {
      this.alertService.openSnackBar('Erreur lors de l\'export', 'snack-error');
    }
  });
}

}


